import React from "react";
import "./index.css";
import ExpandableContent from "../ExpandableComponent";
import Portfolio from '../../assets/portfolio.webp'

const index = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div className="img-container">
        <img className="about-image1" src={Portfolio} alt="Teams" />
        <div class="text-overlay">
          Our Portfolio
        </div>
      </div>
      <ExpandableContent
        heading="Deepak Fasteners Limited (DFL)"
        content="Deepak Fasteners Limited is the largest manufacturer of industrial high tensile fasteners in India. The company’s products are marketed and sold domestically and internationally under the world- renowned brand Unbrako."
      />


      <ExpandableContent
        heading="Indo Shell Mould Limited"
        content="Indo Shell Mould Limited is among India’s leading shell moulding-based precision casting manufacturers. The Company provides end-to-end solutions from R&D and design to manufacturing and maintains long-standing relationships with marquee customers across automotive, hydraulics, and industrial segments."
      />
    </div>
  );
};

export default index;
